import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiResponse } from '../../models/common.model';
import { loadBizShopProducts, loadBizShopProductsFailure, loadBizShopProductsSuccess } from './biz-shop-product.action';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class BizShopProductEffects {
  constructor(private actions$: Actions, private customerService: CustomerService) { }

  // Effect to load filtered products
  loadBizShopProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBizShopProducts),
      switchMap((action: { categoryId?: any, subCategoryId: any, adminId: any, search: any, page: any, limit: any }) =>
        this.customerService.getBizProductList({ categoryId: action.categoryId, subCategoryId: action.subCategoryId, adminId: action.adminId, search: action.search, page: action.page, limit: action.limit }
        ).pipe(
          map((response: ApiResponse) => {
            return loadBizShopProductsSuccess({ bizShopProducts: response.body });
          }),
          catchError((error) =>
            of(
              loadBizShopProductsFailure({
                error: {
                  message: error.message || 'An unknown error occurred',
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )

      )
    )
  );
}
